import { useMemo } from 'react';
import { useAppSelector } from 'store/hooks';
import sortAccounts from 'utils/api/sortAccounts';
import { selectListAccountsFromConnections, selectUserTradingAccounts, } from 'reducers/selectors';
import { selectPotsWithSpaceId } from 'features/pots/reducers/selectors';
import { selectSpaces } from '../reducers/selectors';
export const useMySpaceAccounts = () => {
    const accountsFromConnections = useAppSelector(selectListAccountsFromConnections);
    const spaces = useAppSelector(selectSpaces);
    const pots = useAppSelector(selectPotsWithSpaceId);
    const tradingAccounts = useAppSelector(selectUserTradingAccounts);
    const mySpaceAccounts = useMemo(() => {
        if (!spaces)
            return [];
        const defaultSpaceId = spaces.find((space) => space.isDefault)?.id;
        const accounts = sortAccounts([
            ...accountsFromConnections,
            ...pots,
            ...(tradingAccounts || []),
        ]);
        const accountsBySpaceId = accounts.reduce((acc, curr) => {
            const spaceId = curr.spaceId ?? defaultSpaceId;
            if (!spaceId)
                return acc;
            return { ...acc, [spaceId]: [...(acc[spaceId] || []), curr] };
        }, {});
        return spaces.map((space) => ({
            space,
            accounts: accountsBySpaceId[space.id] || [],
        }));
    }, [spaces, accountsFromConnections, pots, tradingAccounts]);
    const accountsCount = useMemo(() => mySpaceAccounts.reduce((acc, curr) => acc + curr.accounts.length, 0), [mySpaceAccounts]);
    return { mySpaceAccounts, accountsCount };
};
